/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_ZoteroInputs */

const en_pricing_feature_zotero = /** @type {(inputs: Pricing_Feature_ZoteroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero integration`)
};

const es_pricing_feature_zotero = /** @type {(inputs: Pricing_Feature_ZoteroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración con Zotero`)
};

/**
* | output |
* | --- |
* | "Zotero integration" |
*
* @param {Pricing_Feature_ZoteroInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_zotero = /** @type {((inputs?: Pricing_Feature_ZoteroInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_ZoteroInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_feature_zotero(inputs)
	return en_pricing_feature_zotero(inputs)
});